import PageDS from "../PageDS";
import { pagesMap } from "../PagesMap";

export default class getCurrentPageTitleUseCase {
  public static getCurrentPageTitle(currentPage: string): string {
    if (currentPage && pagesMap[currentPage]) return (<PageDS>pagesMap[currentPage]).pageTitle;
    else return "";
  }
}
